import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Liability } from '../../models/liability.model';
import { CustomerBiller } from '../../../billers/models/model';
import { CustomerBillerStoreService } from '../../../billers/services/customer-biller-store.service';
import { ToolbarService } from '../../../core/services/toolbar.service';
import { LiabilityService } from '../../services/liability.service';

@Component({
standalone: false,
  selector: 'app-liability-delagate',
  templateUrl: './liability-delagate.component.html',
  styleUrls: ['./liability-delagate.component.scss'],
})
export class LiabilityDelagateComponent implements OnInit {
  public liability$: Observable<Liability>;
  public customerBiller$: Observable<CustomerBiller>;

  public data$: Observable<LiabilityWithCustomerBillerData>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private toolbar: ToolbarService,
    private liabilityService: LiabilityService,
    private billerStoreService: CustomerBillerStoreService,
  ) {
    this.toolbar.init(this.activatedRoute);
  }

  public ngOnInit() {
    this.loadData();
  }

  private loadData() {
    this.liability$ = this.activatedRoute.paramMap.pipe(
      map((paramMap) => paramMap.get('id')),
      switchMap((id) => this.liabilityService.getLiabilityWithSubscription(id)),
    );

    this.customerBiller$ = this.liability$.pipe(
      switchMap((liability) => this.billerStoreService.getCustomerBiller(liability.customerBillerId)),
    );

    this.data$ = combineLatest([this.liability$, this.customerBiller$]).pipe(
      map(([liability, customerBiller]) => ({ liability, customerBiller })),
    );
  }
}

class LiabilityWithCustomerBillerData {
  public liability: Liability;
  public customerBiller: CustomerBiller;
}
